import React, { ReactNode } from 'react';

import { FormSelect, FormSelectProps } from 'react-bootstrap';

export type OptionsT = {
  label: string;
  value: string | number;
};

export type SelectPropsT = Omit<FormSelectProps, 'bsPrefix, htmlSize'> & {
  id: string;
  label: ReactNode;
  options: OptionsT[];
  errorMessage?: string;
  helperText?: string;
  placeholder?: string;
  success?: boolean;
};
export type SelectT = React.FC<SelectPropsT>;

export const Select: SelectT = ({
  className,
  defaultValue,
  errorMessage,
  helperText,
  id,
  label,
  options,
  placeholder,
  success,
  value,
  ...props
}) => {
  const resolvedDefaultValue = defaultValue ?? (placeholder && value === undefined ? '' : undefined);

  return (
    <div className={className}>
      <label htmlFor={id}>{label}</label>

      {helperText && <span id={`${id}-help`} className="d-block helper-text">{helperText}</span>}

      <FormSelect
        {...props}
        aria-describedby={`${errorMessage ? `${id}-error` : ''} ${helperText ? `${id}-help` : ''}`}
        aria-invalid={!!errorMessage}
        defaultValue={resolvedDefaultValue}
        id={id}
        isInvalid={!!errorMessage}
        isValid={success}
        value={value}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </FormSelect>

      {errorMessage && (
        <div id={`${id}-error`} role="alert" className="feedback invalid-feedback">
          {errorMessage}
        </div>
      )}
    </div>
  );
};
